import type { components } from '../../../types/schema';

type ApiV1CastRelationship = components['schemas']['ApiV1CastRelationship'];

export const getChatDirection = (castRelationship: ApiV1CastRelationship | null, name: string) => {
  if (!castRelationship) return 'left';
  if (!name) return 'left';
  if (name === castRelationship?.personA?.name || name === castRelationship?.personA?.nickname)
    return 'left';
  if (name === castRelationship?.personB?.name || name === castRelationship?.personB?.nickname)
    return 'right';
  return 'left';
};
